import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import './Syles/Innovative.scss';
import image from '../../../Assets/Cards/boxes.webp';
import hbo from '../../../Assets/Icons/hbo.svg';
import bnsf from '../../../Assets/Icons/bnsf2.svg';
import astra from '../../../Assets/Icons/astra.svg';
import gaz from '../../../Assets/Icons/gaz.svg';
import buzzfeed from '../../../Assets/Icons/buzzfeed2.svg';
import ford from '../../../Assets/Icons/ford.svg';
import godaddy from '../../../Assets/Icons/godaddy2.svg';
import udemy from '../../../Assets/Icons/udemy2.svg';
import allianz from '../../../Assets/Icons/allianz2.svg';
import visa from '../../../Assets/Icons/visa2.svg';









const Innovative=()=>{
    return(
        <div className="home-innovative">
          <div className="content">
              <h1>The world's most innovative companies use HostDesign everyday to scale design</h1>
              <p>The digital products, from around the world, that you know and love have been built with HostDesign.</p>
              <p>Our customers range from Fortune 100 companies, to startups and schools - all using our online design platform to ideate fast, collaborate and optimise prototypes before development.</p>
              <StyledButton btn="Read Customer Stories" styles="transparent-btn" />
          </div>
          {/* <svg className="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
  <path fill="#fff" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,218.7C672,213,768,171,864,176C960,181,1056,235,1152,245.3C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
</svg> */}
{/* <img src={image} /> */}

<div className="box1" >
    <img src={hbo} id="first"/>
</div>
<div className="box2" >
<img src={bnsf} />
 </div> 
<div className="box3" >
<img src={astra} />
</div> 
<div className="box4" >
<img src={gaz} />

    </div> 
<div className="box5" >
<img src={buzzfeed} />
</div> 
<div className="box6" >
<img src={godaddy} />

</div> 
<div className="box7" >
<img src={ford} />
    
    </div> 
<div className="box8" >
<img src={udemy} /></div> 
<div className="box9" >
<img src={allianz} />
    </div> 
<div className="box10" >
<img src={visa} />
    </div> 





        </div>
    )
};
export default Innovative;